export default [
  {
    name: 'project_main',
    layout: 'large'
  }
]